import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import HTMLEditor from "../HTMLEditor/HTMLEditor";

const useStyles = makeStyles((theme) => ({
  grid: {
    padding: theme.spacing(1),
    alignSelf: "center",
  },
  question: {
    color: theme.palette.primary.main,
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1),
    },
  },
}));

const CharityInformation = (props) => {
  const classes = useStyles();

  const [formData, setFormData] = useState(props.data);

  useEffect(() => {
    props.onChange(formData);
  }, [formData]);

  const onChange = (event) => {
    setFormData(event.editor.getData());
  }
  return (
    <Grid container>
      <Grid size={{ xs: 12, md: 12 }} className={classes.grid}>
        {/* <TextField
          id="description"
          variant="outlined"
          //label={<Typography variant="body2"></Typography>}
          size="small"
          fullWidth
          multiline
          rows={4}
          value={formData}
          onChange={(e) => setFormData(e.target.value)}
        /> */}
        <HTMLEditor
                    id="description" name="description"
                    data={formData}
                    onChange={onChange}
                    error={undefined}
                />
        </Grid>
    </Grid>
  );
};

export default CharityInformation;
